<!-- Email validation code entry view -->
<section class="form-group" [ngClass]="{ 'd-none': loading }">
  <article
    [ngClass]="theme.getThemeClass()"
    class="wrapper fadeInDown"
    id="formContent"
  >
    <!-- ICON -->
    <nav class="fadeIn first">
      <img class="logo" src="../assets/muirwood-studio.png" />
    </nav>
    <div>
      <h3>{{ "validationCode" | translate }}</h3>
    </div>
    <!-- LOGIN FORM -->
    <form (ngSubmit)="ctx.emailValidate()">
      <div class="form-group fadeIn second">
        <!-- Input for confirmation code received from email -->
        <input
          id="emailValidation"
          type="text"
          [(ngModel)]="ctx.confirmationCode"
          class="form-control"
          name="emailValidation"
          placeholder="{{ 'validationCode' | translate }}"
          required
          autocomplete="off"
        />
      </div>
      <div style="display: flex; flex-direction: column">
        <input
          type="submit"
          skipLocationChange
          class="fadeIn fourth"
          value="{{ 'validateCode' | translate }}"
          height="30px"
        />
        <a
          href="#"
          onclick="return false;"
          (click)="ctx.cognitoService.resendValidationCode()"
          class="fadeIn fourth"
          height="30px"
          >{{ "requestNewCode" | translate }}
        </a>
      </div>
    </form>
  </article>
</section>
